import { useTranslation } from 'react-i18next'

import { usePermissions } from '@/common/hooks/usePermissions'
import {
  ApplicationAccountUserModel,
  ApplicationAccountUserRole,
} from '@/common/models/applicationAccountUser'
import { translateApplicationAccountUserRole } from '@/common/utils/translateApplicationAccountUserRole'

export function useRoleOptionsForApplicationAccountUser() {
  const { t } = useTranslation('common')
  const { can } = usePermissions()

  const ROLE_OPTIONS = Object.values(ApplicationAccountUserRole).map(
    (role) => ({
      label: translateApplicationAccountUserRole(t, role),
      value: role,
    }),
  )

  const ALLOWED_ROLE_OPTIONS = Object.values(ApplicationAccountUserRole)
    .map((role) => ({
      label: translateApplicationAccountUserRole(t, role),
      value: role,
    }))
    .filter((option) =>
      can('create', {
        __typename: 'ApplicationAccountUser',
        role: option.value,
      } as ApplicationAccountUserModel),
    )

  return { ROLE_OPTIONS, ALLOWED_ROLE_OPTIONS }
}
